import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthHeader from './components/Header/AuthHeader';
import AuthFooter from './components/Footer/AuthFooter';

interface AuthLayoutProps {
  header?: React.ReactNode | 'default' | 'none';
  footer?: React.ReactNode | 'default' | 'none';
  bodyClassName?: string;
}

/**
 * Layout component for authentication pages (Login, Activate, Reset Password)
 * Structure: Header (80px) + Body (flex, scrolls) + Footer (80px). The app background
 * (BaseLayout's themed layer) shows through; pages put their content in PageShell.
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({
  header = 'default',
  footer = 'default',
  bodyClassName = '',
}) => {
  return (
    <div className="safe-area-top safe-area-bottom h-dvh flex flex-col overflow-hidden">
      {/* Header - fixed 80px */}
      {header === 'none' ? null : header === 'default' ? (
        <div className="h-20 min-h-20 shrink-0 overflow-hidden">
          <AuthHeader />
        </div>
      ) : (
        header
      )}

      {/* Body - fills remaining height and scrolls */}
      <main className={`min-h-0 min-w-0 flex-1 cosmos-scroll-y overflow-x-hidden overscroll-contain ${bodyClassName}`}>
        <Outlet />
      </main>

      {/* Footer - fixed 80px */}
      {footer === 'none' ? null : footer === 'default' ? (
        <div className="h-20 min-h-20 shrink-0 overflow-hidden">
          <AuthFooter />
        </div>
      ) : (
        footer
      )}
    </div>
  );
};

export default AuthLayout;
